(($, Drupal) => {
  const id = "xencms:node--article--teaser";

  Drupal.behaviors[id] = {
    attach: (context, settings) => {
      $(document).ready(function() {
        $('.node--article--teaser h3', context).matchHeight();
        $('.node--article--teaser .field--node--body', context).matchHeight();
      });
    }
  };


})(jQuery, Drupal);

